module.exports = __webpack_public_path__ + "static/milestone-bg-838caa050a206e63a52fddccaa957b49.jpg";